/**
 * @fileoverview
 * Grid System adjust position by grid component's position.
 */
'use strict';

goog.provide("Ntry.GridSystem");

goog.require("Ntry.STATIC");

Ntry.GridSystem = function() {
    this.width = 0;
    this.height = 0;
    this.tileSize = 0;
};

(function(p){
    p.loadConfig = function() {
        var gridSize = Ntry.configManager.getConfig("gridSize");
        this.width = gridSize.width;
        this.height = gridSize.height;
        this.tileSize = Ntry.configManager.getConfig("tileSize");
    }

    p.update = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.GRID);

        for (var id in entities) {
            var entity = entities[id];
            var grid = Ntry.entityManager.getComponent(
                entity.id, Ntry.STATIC.GRID
            );
            var position = Ntry.entityManager.getComponent(
                entity.id, Ntry.STATIC.POSITION
            );
            if (!position) {
                /* adjust position by grid component */
                position = Ntry.entityManager.addComponent(
                    entity.id, {type: Ntry.STATIC.POSITION}
                );
                position.x = this.tileSize * grid.x + this.tileSize / 2 -
                    this.getScrollX();
                position.y = this.tileSize * grid.y + this.tileSize / 2;
            }
            /*else {
                grid.x = Math.round(position.x / this.tileSize);
                grid.y = Math.round(position.y / this.tileSize);
            }
            */
        }
    }

    p.getScrollX = function() {
        if (!this._scroll) {
            var entities = Ntry.entityManager.getEntitiesByComponent(
                Ntry.STATIC.SCROLL
            )
            if (!entities)
                return 0;
            else {
                var scrollEntity;
                for (var key in entities)
                    this._scroll = Ntry.entityManager.getComponent(
                        key, Ntry.STATIC.SCROLL);
            }
        }
        return this._scroll.scrollX;
    };

})(Ntry.GridSystem.prototype);


